<template>


    <main class="">

        <div class="container my-5">
            <div class="d-flex align-items-center gap-5 position-relative">
                <div 
                    class="bg-secondary bg-gradient border border-5 border-white shadow fs-3 text-white rounded-circle d-flex gap-2 align-items-center justify-content-center" 
                    style="width: 170px; height: 170px;">
                    <i class="bi bi-shield-check"></i> 
                    Silber
                </div>
                <div>
                    <h1 class="display-4 fw-bold">
                        Zahnarztpraxis Dr. Birgit Stepke
                    </h1>
                    <div class="fs-2">
                        Lippetal-Herzfeld
                    </div>
                    <div class="mt-2 fs-6 d-flex gap-5">
                        <div>
                            <i class="bi bi-geo-alt text-primary"></i>
                            Lippborger Str. 10A
                        </div>
                        <div>
                            <i class="bi bi-telephone-fill text-primary"></i>
                            +49(0)2923/610950
                        </div>
                        <div>
                            <i class="bi bi-envelope text-primary"></i>
                            info@zahnarzt-stepke.de
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <img src="/img/customers/praxisteam-zahnarzt-dr-stepke.jpg" alt="" class="img-fluid w-100">
        </div>

        <div class="container" style="position:relative; top: -200px;">

            <div class="p-5 mb-4 bg-light rounded-3">
                <div class="container-fluid py-5">
                    <h1 class="display-5 fw-bold">UNSER PRAXISLEITBILD</h1>
                    <p class="col-md-8 fs-4">„Wir behandeln unsere Patienten nach bestem Wissen und Gewissen und bieten Ihnen ein wesentliches Spektrum in der modernen Zahnheilkunde an.„</p>
                    <button class="btn btn-primary btn-lg" type="button">Mehr erfahren</button>
                </div>
            </div>

            <div class="row align-items-md-stretch">
                <div class="col-md-6">
                    <div class="h-100 p-5 text-bg-dark rounded-3">
                        <h2>Kinderfreundliches Personal</h2>
                        <p>Wir bieten eine kinderschonende Behandlung an. Die Behandler oder auch die Helferinnen erklären die bevorstehende Behandlung auf spielerische Art und Weise und individuell für den kleinen Patienten.</p>
                        <button class="btn btn-outline-light" type="button">Mehr Informationen</button>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="h-100 p-5 bg-light rounded-3">
                        <h2>Intraorale Kamera
                        </h2>
                        <p>Zur Darstellung spezieller Befunde im Mundbereich (z.B. Karies, Zahnstein, Mundschleimhauterkrankung) kann dieses dem Patienten nach Bedarf oder auch nach Wunsch mit Hilfe einer intraoralen Kamera gezeigt werden. Zudem dient es auch Dokumentationszwecken.
                        </p>
                        <button class="btn btn-outline-secondary" type="button">Mehr Informationen</button>
                    </div>
                </div>
            </div>

            <div class="row mt-5 align-items-center">
                <div class="col-4">
                    <img src="/img/customers/dr-birgit-stepke-480x320.jpg" alt="" class="rounded-circle" width="300" height="300" style='object-fit: cover'>
                </div>
                <div class="col-8">
                    <h4 class="display-5 fw-bold">Dr. med. dent. Birgit Stepke</h4>
                    <h5>Zahnärztin und Praxisinhaberin</h5>
                    <p>Für eine optimale Zahngesundheit empfehlen wir eine halbjährliche Kontrolle durch den Zahnarzt. Gerne erinnern wir Sie an Ihre Vorsorgeuntersuchung im Rahmen des Recall-Systems.

                    </p>
                </div>
            </div>

        </div>

    </main>

</template>

<script>
    export default {
        props: [
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>